/*
 *
 * SmartAccuPay - Portal
 *
 * Map component
 *
 * Created by SmartAccuPay.
 * Copyright © 2024 SmartAccuPay. All rights reserved.
 *
 */

import { Location } from '@angular/common';
import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import * as mapboxgl from 'mapbox-gl';
import { SeoService } from 'src/app/seo.service';
import { configData } from 'src/environments/configData';

@Component({
    selector: 'app-map-for-all',
    templateUrl: './map-for-all.component.html',
    styleUrls: ['./map-for-all.component.scss'],
    standalone: false
})

export class MapForAllComponent {
  map: any;
  styleLight = 'mapbox://styles/mapbox/streets-v12';
  darkMode = 'mapbox://sprites/mapbox/dark-v12';
  lat = configData.FLORIDA_LAT;
  lng = configData.FLORIDA_LNG;
  newLat: any;
  newLan: any;
  center: any;
  timecarID: any;
  mapObj: any = [];
  mode: any;
  isBackHide: Boolean = false;

  constructor(private seo: SeoService, public route: ActivatedRoute,
    private location: Location) {
    this.seo.setTags({
      title: 'SmartAccuPay map', // Title
      titleSuffix: '- SmartAccuPay', // Title Suffix
      description: 'SmartAccuPay Invoice Management', // Description
      image: '', // Image
      keywords: 'SmartAccuPay' // Keywords
    });
    this.ngAfterViewInit();
  }

  ngOnInit(): void {
    this.route.queryParams.subscribe((params: any) => {
      const userLng = params.user_lng ?? this.lng;
      const userLat = params.user_lat ?? this.lat;
      const mapStyle = this.mode === 'on' ? this.darkMode : this.styleLight;

      this.initializeMap(userLng, userLat, mapStyle);
      if (params.id) {
        this.getOneAndOpenModal(params.id);
      } else {
        this.addMarker(userLng, userLat, params);
      }
    });
  }

  initializeMap(lng: number, lat: number, style: string): void {
    this.map = new mapboxgl.Map({
      accessToken: configData.MAPBOXAPIKEY,
      container: 'map',
      style: style,
      center: [lng, lat],
      zoom: 12,
      projection: { name: 'globe' },
    });

    this.map.addControl(new mapboxgl.NavigationControl());
  }

  addMarker(lng: number, lat: number, params: any): void {
    const geojson: mapboxgl.GeoJSONSourceRaw | any= {
      type: 'FeatureCollection',
      features: [{
        type: 'Feature',
        geometry: { type: 'Point', coordinates: [lng, lat] },
        properties: {
          id: 0,
          description: `<div style="...">...</div>`, // Customize as needed
        },
      }],
    };

    this.map?.on('load', () => {
      this.map?.addSource('markers', { type: 'geojson', data: geojson });
      this.map?.loadImage(
        '../../../../assets/images/mapbox-marker-icon-20px-green.png',
        (error: any, image: any) => {
          if (error) return console.error(error);
          this.map?.addImage('green', image);
          this.map?.addLayer({
            id: 'point-symbol',
            source: 'markers',
            type: 'symbol',
            layout: { 'icon-image': 'green', 'icon-allow-overlap': true },
            filter: ['==', 'id', 0],
          });
        }
      );
    });
  }


  back(): void {
    this.location.back();
  }

  getOneAndOpenModal(id: any) {
    let that = this;
  }

  ngAfterViewInit() {

  }

  ngOnDestroy() {

  }

}

